import ProgressProduksiApi from './ProgressProduksiApi';

export default ProgressProduksiApi;
